module.exports = require('./lib/visibility.timers.js')



//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/visibilityjs/index.js
// module id = ../../../node_modules/visibilityjs/index.js
// module chunks = commit_pipelines environments environments_folder issue_show job_details pipelines pipelines_details